import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientHelper } from '../http-helper';
import { ApiUrlHelper, UrlQueryParams } from '../api-url-helper';
import { User } from '../../_model/user/user.model';
import { map } from 'rxjs/operators';

@Injectable()
export class WebformService {
    constructor(
        private _httpClientHelper: HttpClientHelper,
        private _apiUrlHelper: ApiUrlHelper,
    ) { }

    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };

    submitForm(user: User, type, content): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('webforms', {
        });

        const body = new UrlQueryParams();

        // body.set('uid', user.id);
        // body.set('gid', user.token.gid);
        // body.set('expire', user.token.expire);
        // body.set('sign', user.token.sign);
        // body.set('token', user.token.token);
        body.set('sdate', user.registerDate);
        body.set('type', type);
        body.set('contxt', JSON.stringify(content));

        return this._httpClientHelper
            .post(apiURL, body.toString(), this.httpOptions)
            .pipe(map(res => {
                return res;
            }));
    }
}
